import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap } from 'react-google-maps';
import MapWrapper from './MapWrapper';


class MainMapWrapper extends Component {
  componentDidMount() {
    this.boundsMap();
  }

  componentDidUpdate() {
    this.boundsMap();
  }

  boundsMap() {
    if (this.props.markersArray.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();

      this.props.markersArray.map((elem) => {
        if (elem.latitude && elem.longitude) {
          bounds.extend(new window.google.maps.LatLng(
            elem.latitude,
            elem.longitude,
          ));

          return elem;
        }

      });
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        const extendPoint1 = new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.001,
          bounds.getNorthEast().lng() + 0.001);
        const extendPoint2 = new window.google.maps.LatLng(bounds.getNorthEast().lat() - 0.001,
          bounds.getNorthEast().lng() - 0.001);

        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
      }
      this.map.fitBounds(bounds);
    }
  }

  render() {
    return (
      <GoogleMap
        ref={(map) => { this.map = map; }}
        zoom={5}
        maxZoom={15}
        defaultOptions={{ mapTypeControl: false, maxZoom: 18 }}
      >
        <MapWrapper markersArray={this.props.markersArray} />
      </GoogleMap>
    );
  }
}

MainMapWrapper.propTypes = {
  markersArray: PropTypes.arrayOf(PropTypes.shape),
};

MainMapWrapper.defaultProps = {
  markersArray: [],
};

export default MainMapWrapper;
